import { jsx } from "@builder.io/qwik/jsx-runtime";
import { component$, useContext, $, sync$, Slot } from "@builder.io/qwik";
import SelectContextId from "./select-context.qwik.mjs";
import { useCombinedRef } from "../../hooks/combined-refs.qwik.mjs";
const HSelectLabel = component$((props) => {
  const context = useContext(SelectContextId);
  const labelId = `${context.localId}-label`;
  const contextRefOpts = {
    context,
    givenContextRef: context.labelRef
  };
  const labelRef = useCombinedRef(props.ref, contextRefOpts);
  const handleClick$ = $(() => {
    if (context.isDisabledSig.value)
      return;
    context.triggerRef.value?.focus();
  });
  const handleMouseDownSync$ = sync$((e) => {
    if (!e.defaultPrevented && e.detail > 1)
      e.preventDefault();
  });
  return /* @__PURE__ */ jsx("div", {
    "data-disabled": context.isDisabledSig.value ? "" : void 0,
    ref: labelRef,
    id: labelId,
    onClick$: [
      handleClick$,
      props.onClick$
    ],
    onMouseDown$: [
      handleMouseDownSync$,
      props.onMouseDown$
    ],
    ...props,
    children: /* @__PURE__ */ jsx(Slot, {})
  });
});
export {
  HSelectLabel
};
